import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	Blade,
	Button,
	Layout,
	ProgressIndicator
} from "rhombus-react";

import CreativesTable from 'widgets/table/CreativesTable';
import EmptySection from 'widgets/EmptySection';
import { closeModal } from 'reducers/Modal';

function PreviewLinkedCreatives(props) {
	const dispatch = useDispatch()
		, { id } = props
		, {
			creatives,
			isLoading,
			hasError,
		} = useSelector((state) => {
			const preview = state.creativePreviews?.items.find(({ id: previewId }) => previewId === id) || {};

			return {
				creatives: preview?.creatives || [],
				isLoading: state.creativePreviews.isLoading,
				hasError: state.creativePreviews.hasErrorLoading,
			};
		})
		, onClose = () => {
			dispatch(closeModal());
		}
	;

	const renderContent = () => {
		let modalContent = null
			, nothingFound = (
				<EmptySection
					header="Linked Creatives Not Found"
					message="We couldn't find the linked creatives for this preview"
					src="/images/noFiles.svg"
				/>
			)
		;

		if (!hasError && creatives.length) {
			modalContent = <CreativesTable className="linked-creatives-table" shouldShowStatus={false} shouldLinkPreview={false} creatives={creatives} />;
		} else {
			modalContent = nothingFound;
		}

		return (
			<div className="linked-creative-container">
				<ProgressIndicator isLoading={isLoading} isOpaque />
				{modalContent}
			</div>
		);
	};

	const renderFooter = () => {
		return (
			<Layout.ModalFooter>
				<Button className="close-button" theme="grey" onClick={onClose}>Close</Button>
			</Layout.ModalFooter>
		);
	};

	return (
		<Blade
			type="modal"
			title="Linked Creatives"
			className="linked-creative-modal"
			allowFullScreen={false}
			bladeProps={{ verticallyCenter: true }}
			xClose
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
		/>
	);
}

export default PreviewLinkedCreatives;
